module.exports = __webpack_public_path__ + "brand-icons.e8c322de9658cbeb8a77.woff2";


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/assets/semantic/themes/default/assets/fonts/brand-icons.woff2
// module id = ../../../../../src/assets/semantic/themes/default/assets/fonts/brand-icons.woff2
// module chunks = styles